// Titres et descriptions de chaque page pour Google (titre ~50-60 caractères, description ~150-160).
export const SEO = {
  "/": {
    title: "Cap Sud - Restaurant et pizzeria à Morangis depuis 2004",
    description: "CAP SUD, restaurant et pizzeria à Morangis depuis 2004 : pizzas à emporter, pâtes, viandes, poissons et location de salle, 1 Place Lucien Boilleau.",
  },
  "/notre-carte": {
    title: "Notre carte : pizzas, pâtes, viandes | Cap Sud Morangis",
    description: "La carte de CAP SUD, restaurant à Morangis : pizzas, pâtes, viandes, poissons, desserts et menu complet du midi, à déguster sur place ou à emporter.",
  },
  "/nos-pizzas": {
    title: "Pizzeria à Morangis : nos pizzas à emporter | Cap Sud",
    description: "Toutes les pizzas de CAP SUD, pizzeria à Morangis depuis 2004. Commandez vos pizzas à emporter : une canette offerte pour chaque pizza à emporter.",
  },
  "/commander-a-emporter": {
    title: "Pizzas et pâtes à emporter à Morangis | Cap Sud",
    description: "Commandez vos pizzas et pâtes à emporter chez CAP SUD à Morangis : choisissez le jour et l’heure de retrait, envoyez la commande par WhatsApp, payez sur place.",
  },
  "/location-de-salle": {
    title: "Location de salle à Morangis pour vos événements | Cap Sud",
    description: "Louez la salle du restaurant CAP SUD à Morangis pour un anniversaire, un mariage ou une fête de famille. Demandez un devis en ligne ou par téléphone.",
  },
  "/informations-pratiques": {
    title: "Horaires, adresse et accès | Cap Sud, restaurant à Morangis",
    description: "Horaires d’ouverture, adresse et itinéraire de CAP SUD, restaurant et pizzeria au 1 Place Lucien Boilleau, 91420 Morangis. Téléphone : 01 64 48 93 38.",
  },
  "/contact": {
    title: "Contact | Cap Sud, restaurant et pizzeria à Morangis",
    description: "Contactez CAP SUD, restaurant et pizzeria à Morangis : appelez le 01 64 48 93 38 ou écrivez-nous via le formulaire pour une question ou un groupe.",
  },
  "/mentions-legales": {
    title: "Mentions légales | Cap Sud, restaurant à Morangis",
    description: "Mentions légales du site de CAP SUD, restaurant et pizzeria situé 1 Place Lucien Boilleau, 91420 Morangis : éditeur, hébergement et propriété intellectuelle.",
  },
  "/politique-de-confidentialite": {
    title: "Politique de confidentialité | Cap Sud Morangis",
    description: "Comment CAP SUD, restaurant et pizzeria à Morangis, utilise et protège les données transmises via son site : contact, location de salle et commandes à emporter.",
  },
  "/conditions-generales-de-vente": {
    title: "Conditions générales de vente | Cap Sud Morangis",
    description: "Conditions générales de vente des commandes à emporter de CAP SUD à Morangis : commande en ligne, retrait au restaurant et paiement sur place au retrait.",
  },
  "/cookies": {
    title: "Gestion des cookies | Cap Sud, restaurant à Morangis",
    description: "Informations sur les cookies et le stockage local utilisés par le site de CAP SUD, restaurant et pizzeria à Morangis, et sur la façon de les gérer.",
  },
};
